var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.render)?_c('g-chart',{attrs:{"type":"PieChart","data":[_vm.header, ..._vm.positiveItems],"options":{ pieHole: _vm.donutHole, height: _vm.height, legend: { position: _vm.position }, ..._vm.options },"create-chart":_vm.drawChart}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }